import numbro from 'numbro';

import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IFeatureFeeAPI {
  feature_id: number;
  feature_key: string;
  name: string;
  fee_category_name: string;
  value: number;
  type: 'FIXED' | 'PERCENT';
}

export default class FeatureFee extends Validatable<FeatureFee> {
  constructor(
    public id: number = undefined,
    public featureKey: string = undefined,
    public name: string = undefined,
    public feeCategoryName: string = undefined,
    public value: number = undefined,
    public type: 'FIXED' | 'PERCENT' = undefined,
  ) {
    super();
  }

  toApi(): IFeatureFeeAPI {
    return {
      feature_id: this.id,
      feature_key: this.featureKey,
      name: this.name,
      fee_category_name: this.feeCategoryName,
      value: this.value,
      type: this.type,
    };
  }

  get valueFormatted() {
    if (!this.value) return DASH;
    if (this.type === 'FIXED') {
      return i18n.global.n(this.value, 'currency');
    }
    return numbro(this.value).format('0.00%');
  }

  static fromObject(obj: object) {
    return super.fromObject(obj, new FeatureFee());
  }

  static fromApi(apiObject: IFeatureFeeAPI) {
    return new FeatureFee(
      apiObject.feature_id,
      apiObject.feature_key,
      apiObject.name,
      apiObject.fee_category_name,
      apiObject.value,
      apiObject.type,
    );
  }
}
